<script setup lang="ts">
import type { NamedValue } from 'vue-i18n';

// PROPS
const {
    keypath,
    params,
    tag = 'span',
    class: className,
} = defineProps<{
    keypath: TranslationKey;
    params?: NamedValue | number | unknown[];
    tag?: 'span' | 'p' | 'div' | 'label';
    class?: string;
}>();

// COMPOSABLES
const { tt } = useTypedI18n();

// DATA
const html = computed(() => (params !== undefined ? tt(keypath, params as NamedValue) : tt(keypath)));
</script>

<template>
    <!--
        Static elements instead of <component :is="tag"> because Vue's SSR compiler
        treats <component> as a component node, dropping v-html during server rendering.
    -->
    <!-- eslint-disable vue/no-v-html -->
    <div v-if="tag === 'div'" :class="className" v-bind="$attrs" v-html="html" />
    <p v-else-if="tag === 'p'" :class="className" v-bind="$attrs" v-html="html" />
    <label v-else-if="tag === 'label'" :class="className" v-bind="$attrs" v-html="html" />
    <span v-else :class="className" v-bind="$attrs" v-html="html" />
    <!-- eslint-enable vue/no-v-html -->
</template>
